/********
 * Simple method for automatically stripping whitespace from a field when the user moves on from that field.
 * Activate by adding trim-spaces=true to the data attribute, like:
 * data: { trim_spaces: true }
 */

class TrimSpaces {
    initialize() {
        let fields_to_trim = document.querySelectorAll('[data-trim-spaces="true"]');
        fields_to_trim.forEach((field) => {
            field.addEventListener('blur', () => {
            field.value = field.value.trim();
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    trimmer = new TrimSpaces();
    trimmer.initialize();
  });